import APIClient from '@/shared/http/clients/api'

const resourceName = 'pastas'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const resourceAddress = `${APIBusinessCommon}/${resourceName}`

const GetAll = (companyId, config = {}) => APIClient.get(`${resourceAddress}/${companyId}`, config)
const GetAllInFolder = (companyId, folderId, config = {}) => APIClient.get(`${resourceAddress}/${companyId}/${folderId}`, config)
const GetDocument = (companyId, documentId, config = {}) => APIClient.get(`${resourceAddress}/${companyId}/documentos/${documentId}`, config)
const GetDocumentFile = (companyId, documentId, config = {}) => APIClient.get(`${resourceAddress}/${companyId}/documentos/${documentId}/arquivo`, config)
const GetReport = (companyId, config = {}) => APIClient.get(`${resourceAddress}/${companyId}/report`, config)
const AddFolder = (data = {}, config = {}) => APIClient.post(`${resourceAddress}`, data, config)
const UpdateFolder = (folderId, data = {}, config = {}) => APIClient.put(`${resourceAddress}/${folderId}`, data, config)
const MoveFolder = (companyId, folderId, parentFolderId, config = {}) => APIClient.patch(`${resourceAddress}/${companyId}/${folderId}/pastapai`, { pastaPaiId: parentFolderId }, config)
const DeleteFolder = (folderId, config = {}) => APIClient.delete(`${resourceAddress}/${folderId}`, config)
const AddDocument = (folderId, data = {}, config = {}) => APIClient.post(`${resourceAddress}/${folderId}/documentos`, data, config)
const UpdateDocument = (folderId, documentId, data = {}, config = {}) => APIClient.put(`${resourceAddress}/${folderId}/documentos/${documentId}`, data, config)
const DeleteDocument = (folderId, documentId, config = {}) => APIClient.delete(`${resourceAddress}/${folderId}/documentos/${documentId}`, config)
const MoveDocument = (companyId, documentId, folderId, config = {}) => APIClient.patch(`${resourceAddress}/${companyId}/documentos/${documentId}/pasta`, { pastaId: folderId }, config)

const DocumentsFolderRepository = {
  GetAll,
  GetAllInFolder,
  GetDocument,
  GetDocumentFile,
  GetReport,
  AddFolder,
  UpdateFolder,
  MoveFolder,
  DeleteFolder,
  AddDocument,
  UpdateDocument,
  DeleteDocument,
  MoveDocument
}

export default DocumentsFolderRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/documentsfolder.js